var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5649 31.8619C13.7421 31.9544 13.9402 32.0015 14.1384 31.9999C14.3365 31.9984 14.533 31.9497 14.7118 31.8556L20.4204 28.8039C22.0392 27.941 23.3069 26.9761 24.2959 25.8527C26.4463 23.4051 27.6206 20.2813 27.5997 17.0602L27.532 6.43517C27.5256 5.21138 26.7218 4.11938 25.533 3.72243L14.9131 0.159303C14.2737 -0.0572148 13.573 -0.0525079 12.9448 0.170286L2.36516 3.8605C1.18284 4.27314 0.393559 5.37298 0.400003 6.59834L0.467655 17.2155C0.488595 20.4413 1.70312 23.551 3.88895 25.9735C4.88764 27.0812 6.1666 28.032 7.80315 28.8808L13.5649 31.8619ZM12.0537 19.3743C12.2921 19.6034 12.6014 19.7163 12.9106 19.7132C13.2199 19.7116 13.5276 19.5955 13.7627 19.3633L20.0013 13.213C20.47 12.7501 20.4652 12.0064 19.9916 11.5498C19.5164 11.0933 18.7513 11.0964 18.2826 11.5593L12.8929 16.8718L10.6861 14.7505C10.211 14.294 9.44745 14.2987 8.9771 14.7615C8.50837 15.2244 8.5132 15.9681 8.98838 16.4246L12.0537 19.3743Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/Shield.691cfbb3b85651159b81d95ec5547ff0.svg";
export { ForwardRef as ReactComponent };